import http from '../../../Utils/http';
import { getAppOriginAndTimezone } from '../../../Utils/getAppOrigin';

const AccountManagerUpdate = {
  name: 'accountManagerUpdate',
  state: {
    loading: false,
    error: '',
    message: '',
  },
  reducers: {
    assignRequested(state) {
      return {
        ...state,
        loading: true,
        error: '',
        message: '',
      };
    },
    assignReceived(state, payload) {
      return {
        ...state,
        loading: false,
        message: payload || 'Account manager assigned successfully.',
        error: '',
      };
    },
    assignFailed(state, payload) {
      return {
        ...state,
        loading: false,
        error: payload,
        message: '',
      };
    },
    clearStatus(state) {
      return {
        ...state,
        loading: false,
        error: '',
        message: '',
      };
    },
  },
  effects: () => ({
    async assignAccountManager({
      userId,
      orgId,
      previousAccountManager = null,
      organizationName = '',
      organizationType = '',
    }) {
      try {
        this.assignRequested();
        const { origin, timezone } = getAppOriginAndTimezone();
        const payload = {
          origin,
          timezone,
          organization_name: organizationName || undefined,
          organization_type: organizationType || undefined,
        };

        if (previousAccountManager?.id) {
          payload.previous_account_manager = {
            id: previousAccountManager.id,
            name: previousAccountManager.name || '',
            email: previousAccountManager.email || '',
          };
        }

        const response = await http.put(
          `savvy/organization/setAccountManager/${userId}/${orgId}`,
          payload
        );
        const message =
          response?.data?.message || 'Account manager assigned successfully.';
        this.assignReceived(message);
        return { success: true, message };
      } catch (err) {
        const errorMessage =
          err?.response?.data?.message ||
          err?.response?.data?.error ||
          err?.message ||
          'Failed to assign account manager';
        this.assignFailed(errorMessage);
        return { success: false, message: errorMessage };
      }
    },
    clearData() {
      this.clearStatus();
    },
  }),
};

export default AccountManagerUpdate;
